import { useSelector } from "react-redux"
import {
    footerHeight,
    footerPaddingBottom,
    //headerHeight,
} from "@app/LayoutSettings"
import { RootState } from "../types"
import { useShouldUseNativeTabBar } from "./nativeTabBar/useShouldUseNativeTabBar"

const useSafeLayoutSettings = () => {
    const safeArea = useSelector((state: RootState) => state.native.safeArea)
    const supportsNativeTabs = useSelector(
        (state: RootState) => state.appEnvConfig.supportsNativeTabs,
    )

    const shouldUseNativeTabBar = useShouldUseNativeTabBar(supportsNativeTabs)

    const safeFooterPaddingBottom = Math.max(footerPaddingBottom, safeArea.bottom)
    // Floating native tabs overlay the full webview; docked tabs already reserve
    // space in native layout. Neither should shorten the web page a second time.
    const safeFooterHeight = shouldUseNativeTabBar ? 0 : footerHeight + safeFooterPaddingBottom
    //const safeHeaderHeight = headerHeight + safeArea.top

    const safeLayoutSettings = {
        safeFooterHeight,
        safeFooterPaddingBottom,
        //safeHeaderHeight,
    }

    return safeLayoutSettings
}

export default useSafeLayoutSettings
